/** "72%" or "—" */
export function formatPercentage(ratio: number | null): string {
  if (ratio === null || Number.isNaN(ratio)) return "—";
  return `${Math.round(ratio * 100)}%`;
}

/** "12m 34s" / "1u 02m 03s" / "Niet voltooid" if either bound is null. */
export function formatDuration(startedAt: Date, finishedAt: Date | null): string {
  if (!finishedAt) return "Niet voltooid";
  const ms = finishedAt.getTime() - startedAt.getTime();
  if (ms <= 0) return "0s";
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}u ${String(m).padStart(2, "0")}m ${String(sec).padStart(2, "0")}s`;
  return `${m}m ${String(sec).padStart(2, "0")}s`;
}

/** "Vandaag" / "Gisteren" / "3 dagen geleden" / "vorige week" / "12 mei 2026" */
export function formatRelativeNL(when: Date | null, now: Date = new Date()): string {
  if (!when) return "Nooit";
  const ms = now.getTime() - when.getTime();
  const day = 24 * 60 * 60 * 1000;
  if (ms < 0) return "binnenkort";
  if (ms < day && now.getDate() === when.getDate()) return "Vandaag";
  if (ms < 2 * day) return "Gisteren";
  const days = Math.floor(ms / day);
  if (days < 7) return `${days} dagen geleden`;
  if (days < 14) return "vorige week";
  if (days < 60) return `${Math.floor(days / 7)} weken geleden`;
  return when.toLocaleDateString("nl-NL", { day: "numeric", month: "short", year: "numeric" });
}

export function formatMode(mode: string): string {
  if (mode === "full") return "Volledig examen";
  if (mode.startsWith("deel-")) return `Alleen Deel ${mode.slice(5)}`;
  return mode;
}
